import { useEffect, useState } from 'react'

const START_SECONDS = 23 * 3600 + 35 * 60 + 14

export function useCountdown(): { h: string; m: string; s: string } {
  const [total, setTotal] = useState(START_SECONDS)

  useEffect(() => {
    const id = window.setInterval(() => {
      setTotal(prev => (prev <= 1 ? START_SECONDS : prev - 1))
    }, 1000)
    return () => window.clearInterval(id)
  }, [])

  const pad = (n: number) => String(n).padStart(2, '0')
  return {
    h: pad(Math.floor(total / 3600)),
    m: pad(Math.floor((total % 3600) / 60)),
    s: pad(total % 60),
  }
}
